import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { aboutService, AboutPage } from '@/services/about-service'
import { toast } from 'sonner'

export function useAbout() {
    const queryClient = useQueryClient()

    const aboutQuery = useQuery({
        queryKey: ['about-page'],
        queryFn: () => aboutService.getAboutPage(),
    })

    const updateAboutMutation = useMutation({
        mutationFn: ({ data, translate }: { data: Partial<AboutPage>, translate?: boolean }) =>
            aboutService.updateAboutPage(data, translate),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['about-page'] })
            toast.success('Hakkımızda sayfası güncellendi')
        },
        onError: (error: any) => {
            console.error('API Error:', error.response?.data)
            toast.error('Güncelleme sırasında bir hata oluştu')
        },
    })

    return {
        about: aboutQuery.data,
        isLoading: aboutQuery.isLoading,
        isError: aboutQuery.isError,
        updateAbout: updateAboutMutation.mutateAsync,
        isUpdating: updateAboutMutation.isPending
    }
}
